import { render, staticRenderFns } from "./SingleSelectGroup.vue?vue&type=template&id=de498f0a&"
import script from "./SingleSelectGroup.vue?vue&type=script&lang=ts&"
export * from "./SingleSelectGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports